import IReportOutput from "@/api/models/IReportOutput";
import IReportSceneOutput from "@/api/models/IReportSceneOutput";

export default function ReportFormData(
  report: IReportOutput,
  scenes: IReportSceneOutput[]
) {
  const d = new FormData();
  d.append("id", report.id);
  d.append("projectId", report.projectId);
  d.append("parentFolderId", report.parentFolderId);
  d.append("startDate", report.startDate);
  d.append("endDate", report.endDate);
  d.append("name", report.title);
  d.append("kind", "file");
  scenes.forEach((s, i) => {
    d.append(`scenes[${i}][id]`, s.id);
    d.append(`scenes[${i}][imageId]`, s.photoId);
    d.append(`scenes[${i}][state]`, s.state);
    d.append(`scenes[${i}][date]`, s.date);
    d.append(`scenes[${i}][note]`, s.note);
    d.append(`scenes[${i}][companyId]`, s.companyId);
  });
  return d;
}
